import SchoolLookUp from './SchoolLookUp'
export default SchoolLookUp



// WEBPACK FOOTER //
// ./src/components/SchoolLookUp/index.js